<template>
  <div class="container pb-5">
    <div class="mt-5 d-flex flex-column align-items-center">
      <h4>{{title}}</h4>
        <p class="mt-3 text-center">
          {{detail}}
        </p>
    </div>
  </div>
</template>

<script>
import paymentService from "../services/payment.service";
import { emptyGuid } from "../libs/util";
export default {
  data() {
    return {
      paymentData: null
    };
  },
  computed: {
    hasPayment() {
      return !!this.paymentData;
    },
    title() {
      if (!this.hasPayment) return "ไม่พบข้อมูลการชำระเงิน";
      else if (this.paymentData.status == 0)
        return "การชำระเงินกำลังดำเนินการตรวจสอบ";
      else if (this.paymentData.status == 1) return "การชำระเงินสำเร็จ";
      else if (this.paymentData.status == 2)
        return "การชำระเงินไม่สำเร็จ กรุณาดำเนินการใหม่";
      else if (this.paymentData.status == 3) return "การชำระเงินถูกยกเลิก";
      else return "";
    },
    detail() {
      if (!this.hasPayment) return "";
      else if (this.paymentData.status == 0)
        return "";
      else if (this.paymentData.status == 1) return "";
      else if (this.paymentData.status == 2)
        return "Message : " + this.paymentData.reason;
      else if (this.paymentData.status == 3) return "";
      else return "";
    }
  },
  methods: {},
  mounted() {
    const self = this;
    const paymentId = this.$route.params.paymentId || emptyGuid;
    paymentService.getAccountPayment(paymentId).then(res => {
      self.paymentData = res.data;
    });
  }
};
</script>

<style>
.root-container {
  width: 100%;
}
</style>
